<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <span class="text-indigo-400 font-small">Datos </span>del Proyecto
    </h1>
         <div class="bg-white rounded-md shadow overflow-hidden max-w-4xl" style="margin: 15px;">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <div class="container pb-8 pr-6 w-full lg:w-6/6">
              <label class="form-label" >Proyecto:</label>
            <v-select v-model="form.project_id" :onchange="cambia()" :options="projects" value="id" label="nombre"></v-select>
            </div> 
              <div class="bg-white rounded-md shadow overflow-x-auto">
              <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="px-6 pt-6 pb-4">-</th>

                  <th class="px-6 pt-6 pb-4">Categoria</th>
                  <th class="px-6 pt-6 pb-4">Costo m2</th>
                  <th class="px-6 pt-6 pb-4">Plazo Meses</th>
                  <th class="px-6 pt-6 pb-4">Entrada</th>
                  <th class="px-6 pt-6 pb-4">Valor de Contado</th>
                </tr>
                <tr v-for="project in dataProjects" :key="project.id" class="items-center hover:bg-gray-100 focus-within:bg-gray-100">
                  <td class="items-center border-t">
                    <inertia-link class="px-4 flex items-center" :href="route('cotizadors.create', project.id)" tabindex="-1">
                    <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                  </inertia-link>
                  </td>
                  <td class="px-6 py-4 border-t">
                    <inertia-link class="px-4 flex items-center" :href="route('cotizadors.create', project.id)" tabindex="-1">
                      {{ project.categoria }}
                      </inertia-link>
                  </td>
                  <td class="px-6 py-4 border-t">
                      $ {{ project.costo_m2 }}
                  </td>
                  <td class="px-6 py-4 items-center border-t">
                      {{ project.plazo_meses }}
                  </td>
                  <td class="px-6 py-4 items-center border-t">
                      $  {{ project.entrada }}
                  </td>
                
                  <td class="px-6 py-4 items-center border-t">
                      $ {{ project.valor_contado}} 
                  </td>
                  <td class="px-6 py-4 border-t">
                      {{ project.created_at}}
                  </td>
                </tr>
                <tr v-if="dataProjects.length === 0">
                  <td class="border-t px-6 py-4" colspan="4">No Encontramos Tipos</td>
                </tr>
              </table>
              <br>
            <br>
            <br>
              </div>
            
          
            <br>
            <br>
            <br>
        </div>
         </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Vue from 'vue'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from 'axios'
import VueAxios from 'vue-axios'

export default {
  metaInfo: { title: 'Cliente' },
  components: {
    LoadingButton,
    vSelect,
    TextInput,
    Icon,
    axios,
    VueAxios,
    Vue,
  },
  layout: Layout,
  props: {

    proyectos: Array,
  },
  remember: 'form',
  data() {
    return {
      projects: this.proyectos,
      dataProjects: [],
      form: this.$inertia.form({
        project_id: null,
        area: null,
        entrada: null,
        tasa: null,
        descuento: null,
        plazo: null,
        ver: null,
        tipo: null
      }),
      imagenminiatura: '',
    }
  },
  mounted(){
   
  },
  methods: {
    store() {
      this.form.post(this.route('projects.store'))
    },
    cambia(){
      this.axios.get('/typeLands',{ params: { project_id: this.form.project_id} }).then((response) => {
        this.dataProjects=response.data;
        });
    }
  },
}
</script>
